/**
 * Add Student Actions
 *
 * Actions for managing the add student form in the NGXS store.
 */

import { Student } from 'src/app/models/schema';

/**
 * Initialize add student form
 */
export class InitializeAddStudent {
  static readonly type = '[AddStudent] Initialize';
}

/**
 * Set student field value
 */
export class SetStudentField {
  static readonly type = '[AddStudent] Set Field';
  constructor(public field: keyof Student, public value: any) {}
}

/**
 * Update multiple student fields
 */
export class UpdateStudentFields {
  static readonly type = '[AddStudent] Update Fields';
  constructor(public updates: Partial<Student>) {}
}

/**
 * Reset add student form
 */
export class ResetAddStudent {
  static readonly type = '[AddStudent] Reset';
}

/**
 * Set student data (e.g., when editing)
 */
export class SetStudentData {
  static readonly type = '[AddStudent] Set Data';
  constructor(public student: Partial<Student>) {}
}

/**
 * Clear add student form
 */
export class ClearAddStudent {
  static readonly type = '[AddStudent] Clear';
}

